import { render, staticRenderFns } from "./CampaignRefDomains.vue?vue&type=template&id=4e31fd30&"
import script from "./CampaignRefDomains.vue?vue&type=script&lang=js&"
export * from "./CampaignRefDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports